import posthog from 'posthog-js';

export default {
  install(app) {
    app.config.globalProperties.$posthog = posthog.init(
      // eslint-disable-next-line no-undef
      process.env.STUUT_POSTHOG,
      {
        api_host: 'https://us.i.posthog.com',
        autotrack: {
          element_allowlist: ['a', 'button', 'input'],
          dom_event_allowlist: ['click', 'submit'],
        },
      },
    );
  },
};
